module.exports = __webpack_public_path__ + "img/tripolar.add4f7a6.svg";